import { render, staticRenderFns } from "./findDirection.vue?vue&type=template&id=63054d2c&scoped=true"
import script from "./findDirection.vue?vue&type=script&lang=js"
export * from "./findDirection.vue?vue&type=script&lang=js"
import style0 from "./findDirection.vue?vue&type=style&index=0&id=63054d2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63054d2c",
  null
  
)

export default component.exports